import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { CreditFormDataService } from "common/services/data-services/admin/credit/credit-form-data.service";
import { CreditModel } from "common/models/page-models/credits/credit-data-model";
import { CreditMetaModel } from "common/models/page-models/credits/credit-meta-model";
import { BatchesGridDataService } from "common/services/data-services/admin/batches/batches-grid-data.services";
import { TypesListDataService } from "common/services/data-services/custom-service/types-service";



@Injectable({
    providedIn: 'root'
})
export class  CreditFormWidgetService extends FormWidgetService<CreditModel> {
    constructor(protected ds: CreditFormDataService, private typesService: TypesListDataService, private batchService: BatchesGridDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new CreditMetaModel();
        return meta.getMetaModel();
    }

  
    override prepareMetaModel(dataModel: DataModel, metaModel: CreditMetaModel, routeData: WidgetModel): Promise<CreditMetaModel> {
        return new Promise<CreditMetaModel>((resolve, reject) => {
            metaModel.pageTitle = dataModel.id !== 0 ?  'Update Credit' : 'Add Credit';
            // metaModel.properties['branchCategoryId'].options = this.ss.dataStorage.branchCategory;
            this.typesService.postData('').then((data) => {
                metaModel.properties['type_id'].options = data.details;
            });
            this.batchService.postData('').then((data) => {
                metaModel.properties['batch_id'].options = data.details;
            })
            resolve(metaModel);
        });
    }
}
